import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import SpaCarosle from "../../Components/SpaCarosle";
import axios from "../../axios";
import Green from "../../assets/images/icons/green-leaf.png";
import { Button, Modal } from "react-bootstrap";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { Accordion, AccordionTab } from "primereact/accordion";
import StationaryButton from "./StationaryButton";
import TaxInclusive from "../../Components/TaxInclusive.";
import ViewStationaryCartModal from "../../Components/ViewStationaryCartModal";
import { useCartStore } from "../../store/useStore";
function Stationary() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const [service, setService] = useState([]);
  const [countSer, setCountSer] = useState([]);

  const [showError, setShowError] = useState(false);
  const [loading, setLaoding] = useState(false);
  const [title, setTitle] = useState();
  const [hcServices, setHcServices] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const { t, i18n } = useTranslation();

  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
    ReactGA.event({
      category: "Click on Add Item in laundry page ",
      action: "Click",
      value: ``,
    });
  };

  console.log("services", service);

  const toggleService = (input, name, working_times) => {
    console.log("working_times", working_times);
    if (service.includes(input)) {
      ReactGA.event({
        category: "Add HouseKeeping",
        action: "Click",
        value: `HouseKeeping: ${name}`,
      });
      setService((prev) => {
        return prev.filter((x) => x !== input);
      });
    } else {
      setService((prev) => [...prev, input]);
    }
    console.log(service);
  };
  const lang = sessionStorage.getItem("lang");
  const currency = localStorage.getItem("currency");

  const { stationaryCart } = useCartStore((state) => ({
    stationaryCart: state.stationaryCart,
  }));

  const handleBook = () => {
    navigate(`/${room_uuid}/StationaryOrderPayment`);
  };

  const handleClose = () => setShow(false);

  useEffect(() => {
    const getData = async () => {
      setLaoding(true);
      axios
        .get(`/${room_uuid}/stationary`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          if (res.data.status === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res.data.data;
            setHcServices(data.stationaryServices);
            setTitle(data.title);
            console.log(data);
            setLaoding(false);
          }
        })
        .catch((err) => {
          if (err?.response.status == 404) {
            navigate(`/not-found`);
          }
        });
    };
    getData();
  }, []);

  console.log("items", hcServices);
  // const price = 100;
  return (
    <>
      <HeaderInner headerName={title} />
      <main className="home-main bg-white back-white pad-top-0 house">
        {loading ? (
          <SpaLoader />
        ) : (
          <>
            <SpaCarosle noDots={true} autoPlay={true} stationary={true} />
            <div className="housekeeping-container">
              <Button
                className="reg-btn big d-flex justify-content-center align-items-center laundary-add-btn"
                onClick={handleShow}
              >
                <i className="fa-solid fa-plus"></i>
                <span>{t("Add Item")}</span>
                <span></span>
              </Button>
              {/* {hcServices &&
                hcServices.map((category, idx) => {
                  const isCategoryGroup = Array.isArray(category?.services);

                  if (!isCategoryGroup) {
                    return (
                      <div
                        className="service-container"
                        key={category?.id || idx}
                      >
                        <StationaryButton
                          item={category}
                          service={service}
                          setService={setService}
                          countSer={countSer}
                          setCountSer={setCountSer}
                        />
                      </div>
                    );
                  }

                  return (
                    <div key={category?.category_id || idx}>
                      <p className="service">
                        {t(`${category?.category_name}`)}
                      </p>
                      <div className="service-container">
                        {category.services.map((serviceItem, serviceIdx) => (
                          <StationaryButton
                            key={serviceItem?.service_id || serviceIdx}
                            item={{
                              ...serviceItem,
                              id: serviceItem?.service_id,
                              name: serviceItem?.service_name,
                            }}
                            service={service}
                            setService={setService}
                            countSer={countSer}
                            setCountSer={setCountSer}
                          />
                        ))}
                      </div>
                    </div>
                  );
                })} */}
              {/* {showError ? (
                <p className="no-service">{t("Choose a service")} </p>
              ) : null}
              <div className="book">
                <Button
                  onClick={handleBook}
                  disabled={stationaryCart.length == 0}
                  className="reg-btn"
                >
                  {t("Submit Order")} ({stationaryCart.length})
                </Button>
                <h3 className="text-center">
                  <TaxInclusive />
                </h3>
              </div> */}
            </div>
          </>
        )}
        <ViewStationaryCartModal
          show={show}
          handleClose={handleClose}
          services={hcServices}
        />
      </main>
    </>
  );
}
export default Stationary;
